import { computed } from 'vue'

import api from '@/store/api'
import { mapType } from '@/store/mappers'

// The discount codes an agent offer can mention, loaded once per step that offers them.
export const useAgentDiscountCodes = () => {
  api.call('GET', 'discount_codes?included=none')
  return computed(() => mapType('discount_code'))
}
